export default __webpack_public_path__ + "static/media/SpotSnap.e53dedf26cadfce5df1a9b52876f00a6.webp";